module.exports = __webpack_public_path__ + "img/AccountBalanceWalletOutlined.5dc5ecbd.svg";